module.exports = __webpack_public_path__ + "img/hb-2.9b715d7f.png";